<template>
  <div class="liu pos-manage">
    <mt-header fixed title="进件记录" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
      <mt-button slot="right" @click="visible.search=true">更多</mt-button>
    </mt-header>
    <!-- 主页内容 -->
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="5">
      <mt-loadmore ref="loadmore" :top-distance="50" :top-method="onLoadMoreTop">
        <!-- 空页 -->
        <div v-if="isShowEmptyData" />
        <!-- 列表信息 -->
        <div class="form mt-15" v-if="isShowListData">
          <div class="row" v-for="(item, index) in myData.list" :key="index" @click="onListRowClick(item)">
            <div class="item">
              <div class="label">
                <img src="../../assets/customer_settle_records@3x.png" alt="">
              </div>
              <div class="content list">
                <div class="cell pb">
                  <span class="company-name">{{item.companyName}}</span>
                  <span class="status">{{item.status | statusChs}}</span>
                </div>
                <div class="cell">
                  <span class="type">{{item.subjectType | subjectTypeChs}}</span>
                  <span class="date">{{item.insertDate}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 无数据占位图 -->
        <div v-if="isShowNoData">
          <div class="no-data">
            <img src="../../assets/bitmap_agent@3x.png" width="60%" />
            <div class="title-4"> 点击右上角 <span @click="visible.search = true">更多</span> 查看更多商户进件记录 </div>
          </div>
        </div>
      </mt-loadmore>
    </div>
    <!-- 筛选页内容 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="right" :modal="false">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 商户名 -->
          <div class="content-box">
            <div>
              <span>商户名称</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="myParam.companyName" placeholder="请输入商户名称" />
            </div>
          </div>
          <!-- 进件类型 -->
          <div class="content-box">
            <div>
              <span>进件类型</span>
            </div>
            <div class="clearfix">
              <span type="default" class="star" :class="{ 'select-star': myParam.subjectType===item.value }" v-for="(item, index) in search.subjectTypeStatus.list" :key="index" @click="myParam.subjectType=item.value">
                {{ item.name }}
              </span>
            </div>
          </div>
          <!-- 状态 -->
          <div class="content-box">
            <div>
              <span>状态</span>
            </div>
            <div class="clearfix">
              <span type="default" class="star" :class="{ 'select-star': myParam.status===item.value }" v-for="(item, index) in search.status.list" :key="index" @click="myParam.status=item.value">
                {{ item.name }}
              </span>
            </div>
          </div>
          <!-- 注册时间 -->
          <div class="content-box">
            <div>
              <span>进件时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="onSearchDateClick('startDate')">{{ picker.startDateText }}</span>
              -
              <span class="date" @click="onSearchDateClick('endDate')">{{ picker.endDateText }}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="onSearchBtnCancelClick">取消</span>
          <span class="blue" @click="onSearchBtnSubmitClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 日期选择控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm" />
  </div>
</template>

<script>
import { QueryCustomerList } from '@/api/customer';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { formatDate } from '@/utils/utils';

export default {
  name: 'PosManageList',
  data() {
    return {
      // 列表数据模型
      myData: {
        list: [],
        total: -1,
        scrollDisabled: true,
      },
      // 查询条件模型
      myParam: {
        companyName: '',
        endDate: '',
        pageNum: 1,
        pageSize: 12,
        sortType: 0,
        startDate: '',
        status: -1,
        subjectType: -1,
      },
      // 查询组件模型
      search: {
        // 状态
        status: {
          list: [
            { name: '全部', value: -1 },
            { name: '审核中', value: 1 },
            { name: '审核通过', value: 5 },
            { name: '审核不通过', value: 6 },
            { name: '商户已建', value: 7 },
          ],
        },
        subjectTypeStatus: {
          list: [
            { name: '全部', value: -1 },
            { name: '营业执照', value: 0 },
            { name: '小微商户', value: 1 },
          ],
        },
      },
      // 日期组件模型
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关模型
      visible: {
        search: false,
      },
      // 虚拟数据
      listData: [
        { companyName: '吉亚伟业科技有限公司', date: '2022-10-10 12:12', type: '营业执照', status: '待审核' },
        { companyName: '吉亚伟业科技有限公司-2', date: '2022-10-10 12:12', type: '营业执照', status: '待审核' },
        { companyName: '吉亚伟业科技有限公司-3', date: '2022-10-10 12:12', type: '营业执照', status: '待审核' },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initData();
    });
  },
  computed: {
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowListData() {
      return this.myData.total > 0;
    },
    isShowNoData() {
      return this.myData.total === 0;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 页数置1
      this.myParam.pageNum = 1;
      // 加载数据
      this.getDateBase(() => {
        this.getMyData();
      });
    },
    // 通过接口获取数据
    getMyData(callback = null) {
      CusLoadingOpen();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      QueryCustomerList(this.myParam)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.myData.total = res.total;
              this.myData.list.push(...res.rows);
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 下拉刷新
    onLoadMoreTop() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 页数置1
      this.myParam.pageNum = 1;
      // 加载数据
      this.getDateBase(() => {
        this.getMyData(() => {
          this.$refs.loadmore.onTopLoaded();
        });
      });
    },
    // 代理商列表日期查询条件
    getDateBase(callback) {
      this.picker.startDateBase = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
      this.picker.endDateBase = new Date();
      this.picker.startDateText = formatDate(this.picker.startDateBase);
      this.picker.endDateText = formatDate(this.picker.endDateBase);
      callback && callback();
    },
    // 置空所有筛选窗口数据
    clearSearchData() {},
    // 列表页返回按钮点击事件
    onBackBtnClick() {
      this.$router.go(-1);
    },
    // 列表行点击事件
    onListRowClick(item) {
      this.$router.push({ path: '/posmanagemodule/posdetail', query: { id: item.id, eaStatus: item.eAgreementStatus } });
    },
    // 查询-日期框单击事件
    onSearchDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 查询-取消按钮单击事件
    onSearchBtnCancelClick() {
      this.visible.search = false;
      this.clearSearchData();
    },
    // 查询-确定按钮单击事件
    onSearchBtnSubmitClick() {
      // 1.滚动条置顶
      window.scrollTo(0, 0);
      // 2.关闭查询窗口
      this.visible.search = false;
      // 3.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 4.重置列表数据
      this.myData.list = [];
      // 5.重置翻页页数
      this.myParam.pageNum = 1;
      // 6.重置总数
      this.myData.total = -1;
      // 7. 加载数据
      this.getMyData();
    },
    // 日期控件-确定事件
    onDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
  },
  filters: {
    subjectTypeChs(val) {
      if (val === 0) return '营业执照';
      if (val === 1) return '小微商户';
      if (val === 2) return '商户自助注册邀请码';
    },
    statusChs(val) {
      if (val === 1) return '审核中';
      if (val === 5) return '审核通过';
      if (val === 6) return '审核不通过';
      if (val === 7) return '商户已建';
    },
  },
};
</script>
